import { FC } from 'react'

import Button from 'components/uiKit/Button'
import { t } from 'services/Translation'

import * as s from '../AccessGate.module.scss'

interface IAnonymousAccessProps {
  onContinue: () => void
}

export const AnonymousAccess: FC<IAnonymousAccessProps> = ({ onContinue }) => {
  const buttonLabel = t('contentSpace.public.login')

  return (
    <div className={s.actions}>
      <Button name='continueAnonymous' onClick={onContinue}>
        {buttonLabel}
      </Button>
    </div>
  )
}
